type TImageProps = React.ComponentPropsWithoutRef<"img"> & {
  containerClass?: string;
};

const Image = ({ containerClass, ...rest }: TImageProps) => {
  return (
    <div
      className={`select-none pointer-events-none flex items-center justify-center ${containerClass} `}
    >
      <img
        {...rest}
        src={rest?.src}
        alt={rest.alt}
        className={rest.className}
        loading="lazy"
      />
    </div>
  );
};

export default Image;
